import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiKey } from "../../../config/config";
import { languageHelper } from "../../../config/helperFunctions";

function AssignDeliveryCompanies() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const { id } = useParams();
  const [companies, setCompanies] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]); // <-- keep track of checked companies + prices
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  const navigate = useNavigate();

  // Toggle checkbox
  const handleCheck = (companyId) => {
    setSelectedCompanies((prev) => {
      if (prev.find((c) => c.delivery_company_id === companyId)) {
        // uncheck -> remove
        return prev.filter((c) => c.delivery_company_id !== companyId);
      } else {
        // check -> add with empty price
        return [...prev, { delivery_company_id: companyId, sale_price: "" }];
      }
    });
  };

  // Handle sale price input
  const handlePriceChange = (companyId, price) => {
    setSelectedCompanies((prev) =>
      prev.map((c) =>
        c.delivery_company_id === companyId ? { ...c, sale_price: price } : c
      )
    );
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    // filter out empty prices
    const payload = {
      delivery_companies: selectedCompanies.filter((c) => c.sale_price !== ""),
    };

    if (payload.delivery_companies.length === 0) {
      alert("Please select at least one delivery company and set a price.");
      return;
    }

    setLoading(true);
    try {
      await axios.put(
        `${apiKey}/api/rms/admin/food-menu/${id}/delivery-company-prices`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );
      alert("Delivery companies assigned successfully!");
      navigate(-1);
    } catch (err) {
      console.error(err);
      alert("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setPageLoading(true);

    Promise.all([
      axios.get(`${apiKey}/api/rms/admin/deliveryCompanies`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          isActive: true,
        },
      }),
      axios.get(
        `${apiKey}/api/rms/admin/food-menu/${id}/delivery-company-prices`,
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      ),
    ])
      .then(([companiesRes, selectedRes]) => {
        setCompanies(companiesRes.data);
        setSelectedCompanies(selectedRes.data);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setPageLoading(false));
  }, [id, user?.token]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-d-bg-text text-2xl">Assign Delivery Company</h1>
        </div>
        <div className="w-full">
          <form className="w-full" onSubmit={handleSubmit}>
            <div className="">
              {companies.map((company, idx) => {
                const isChecked = selectedCompanies.some(
                  (c) => c.delivery_company_id === company.id
                );
                const companyObj = selectedCompanies.find(
                  (c) => c.delivery_company_id === company.id
                );
                return (
                  <div
                    key={idx}
                    className="grid grid-cols-2 gap-4 items-center"
                  >
                    <div className="inline-flex items-center">
                      <label
                        className="relative flex items-center p-3 rounded-full cursor-pointer"
                        htmlFor={`company-${company.id}`}
                      >
                        <input
                          type="checkbox"
                          id={`company-${company.id}`}
                          checked={isChecked}
                          onChange={() => handleCheck(company.id)}
                          value={company.id}
                          className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all 
        before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 
        before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 
        before:opacity-0 before:transition-opacity 
        checked:border-d-bg checked:bg-d-bg checked:before:bg-d-bg hover:before:opacity-10"
                        />
                        <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-3.5 w-3.5"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            stroke="currentColor"
                            strokeWidth="1"
                          >
                            <path
                              fillRule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                        </span>
                      </label>
                      <label htmlFor={`company-${company.id}`} className="ml-2">
                        {company.company_name}
                      </label>
                    </div>

                    {isChecked && (
                      //   <input
                      //     type="text"
                      //     placeholder="Sale Price"
                      //     value={companyObj?.sale_price || ""}
                      //     onChange={(e) =>
                      //       handlePriceChange(company.id, e.target.value)
                      //     }
                      //     className="border rounded-md p-2"
                      //   />
                      <label htmlFor="" className="w-full">
                        <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                          {languageHelper("Sale Price")}
                        </span>
                        <div className="mb-2 pt-0">
                          <input
                            type="text"
                            placeholder={languageHelper("Sale Price")}
                            name="company_name"
                            value={companyObj?.sale_price || ""}
                            onChange={(e) =>
                              handlePriceChange(company.id, e.target.value)
                            }
                            className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                          />
                        </div>
                      </label>
                    )}
                  </div>
                );
              })}
            </div>
            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none relative"
                type="submit"
                disabled={loading}
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper("Submit")}
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper("Back")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AssignDeliveryCompanies;
